import React from "react";
import { Location } from "@navigation";
import { CustomerContractEditor } from "../CustomerContractEditor/CustomerContractEditor";

interface Params {
  id: string;
}

export class CustomerContractEditorLocation extends Location<Params> {
  constructor(id: string) {
    super({ id });
  }

  render() {
    return <CustomerContractEditor id={this.params.id} />;
  }

  toURI(): string {
    return `/customer_contracts/${this.params.id}/edit`;
  }
}
